import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import styles from "./ModalTandC.module.css";
import Header from "../Header/Header";
import { Markup } from "interweave";

export const ModalTandC = ({
  open,
  onOpenModal,
  onCloseModal,
  handleDisablebtn,
  data,
}) => {
  return (
    <div>
      {/* <button onClick={onOpenModal}>Open modal</button> */}
      <Modal open={open} showCloseIcon={false} onClose={onCloseModal} center>
        {/* <Header title={"Submit Bill"} customMg={"0px"} /> */}
        <Header
          title={"Terms and Conditions"}
          customMg={"0px"}
          closeBtn={true}
          onClose={onCloseModal}
        />
        <div className={styles.MainDivSB}>
          {data &&
            data.map((e, i) => {
              return (
                <>
                  <Markup className="marginTandCinRrqtitle" content={e.title} />

                  <Markup className="marginTandCinRrqdesc" content={e.desc} />
                </>
              );
            })}
        </div>
      </Modal>
    </div>
  );
};
